import { KText } from '@/ui-library/components/text';

export interface MaxLengthCounterProps {
  currentLength: number;
  maxLength: number;
  disabled?: boolean;
}

/**
 * `<current>/<max>` indicator for length-capped fields.
 *
 * Inputs and textareas both cap typing/pasting via the native `maxLength`
 * attribute, which truncates silently — without this counter the user has no
 * way to tell why their text stopped (CORE-5052 / ENG-3553).
 *
 * Positioning is the caller's job: `InputField` renders it inline inside the
 * `InputGroup`, `TextareaField` renders it right-aligned under the textarea.
 */
export function MaxLengthCounter({
  currentLength,
  maxLength,
  disabled,
}: MaxLengthCounterProps) {
  // Red for the cap, and only the cap. It used to take the field's own error
  // state, which is true for a required field that is empty — so an untouched
  // box read "0/250" in red while nothing about its length was wrong (Venil,
  // QA sanity round 1).
  const atCap = currentLength >= maxLength;
  return (
    <KText
      size="xs-medium"
      pr="5px"
      background={'transparent'}
      borderTopRightRadius="6px"
      borderBottomRightRadius="6px"
      color={disabled ? 'secondary-300' : atCap ? 'error-200' : 'secondary-700'}
    >
      {currentLength}/{maxLength}
    </KText>
  );
}
